import React from "react";
import DataGrid, {
  Column,
  FilterRow,
  SearchPanel,
  HeaderFilter,
  Paging,
  Pager
} from "devextreme-react/data-grid";

export default function SavedQueriesGrid({ savedQueries, onLoadSavedQuery }) {
  return (
    <div className="card">

      <div className="section-header">
        <h3>Saved Queries</h3>
      </div>

      <DataGrid
        dataSource={savedQueries}
        keyExpr="id"
        showBorders
        columnAutoWidth
        rowAlternationEnabled
         style={{
            maxHeight: "300px"
          }}
        hoverStateEnabled
        onRowDblClick={(e) => onLoadSavedQuery && onLoadSavedQuery(e.data)}
      >
        {/* SEARCH + FILTER */}
        {/* <SearchPanel visible width={240} placeholder="Search..." /> */}
        {/* <FilterRow visible /> */}
        <HeaderFilter visible />

        {/* PAGINATION */}
        <Paging defaultPageSize={10} />
        <Pager
          showPageSizeSelector
          allowedPageSizes={[10, 25, 50]}
          showInfo
        />

        {/* COLUMNS */}
        <Column dataField="name" caption="Name" />
        <Column dataField="description" caption="Description" />
        <Column dataField="queryType" caption="Type" />
        <Column dataField="visibility" caption="Visibility" />
        <Column dataField="versionNumber" caption="Version" />
       <Column dataField="ownerUserName" caption="Owner" />
        <Column dataField="lastRunStatus" caption="Last Status" />
        <Column
          dataField="createdDate"
          caption="Created"
          dataType="date"
          format="MM/dd/yyyy"
        />
      </DataGrid>

      <div className="hint">
        Double-click a saved query to load it into the editor.
      </div>

    </div>
  );
}